import AutoScroll from 'embla-carousel-auto-scroll';
import useEmblaCarousel from 'embla-carousel-react';
import { Trans, useTranslation } from 'react-i18next';

import useDarkMode from '../../hooks/useDarkMode';

import {
  BrandheroWorkingOnComputerDark,
  BrandheroWorkingOnComputerLight,
  CheckmarkWhiteIcon,
  CodeWaveLogo,
  CodeWaveWhiteLogo,
  CreditAgricoleLogo,
  CreditAgricoleWhiteLogo,
  GriersonTrustLogo,
  GriersonTrustWhiteLogo,
  IteoLogo,
  IteoWhiteLogo,
  JTILogo,
  JTIWhiteLogo,
  PMILogo,
  PMIWhiteLogo,
  SurferLogo,
  SurferWhiteLogo,
  WoodenHamsterLogo,
  WoodenHamsterWhiteLogo,
} from '../../images/shapes';

const VALUES = [
  {
    key: 'create',
    translationKey: 'SignUpInfo.CreateYourWay',
  },
  {
    key: 'connect',
    translationKey: 'SignUpInfo.ConnectYourTools',
  },
  {
    key: 'grow',
    translationKey: 'SignUpInfo.GrowTogether',
  },
];

const LOGOS = [
  {
    key: 'pmi',
    logo: (
      <PMILogo className="h-10" title="Project Management Institute Poland" />
    ),
    logoDark: (
      <PMIWhiteLogo
        className="h-10"
        title="Project Management Institute Poland"
      />
    ),
  },
  {
    key: 'ca',
    logo: <CreditAgricoleLogo className="h-6" title="Credit Agricole" />,
    logoDark: (
      <CreditAgricoleWhiteLogo className="h-6" title="Credit Agricole" />
    ),
  },
  {
    key: 'surfer',
    logo: <SurferLogo className="h-5" title="Surfer SEO" />,
    logoDark: <SurferWhiteLogo className="h-5" title="Surfer SEO" />,
  },
  {
    key: 'iteo',
    logo: <IteoLogo className="h-6" title="Iteo" />,
    logoDark: <IteoWhiteLogo className="h-6" title="Iteo" />,
  },
  {
    key: 'jti',
    logo: <JTILogo className="h-8" title="Japan Tobacco International" />,
    logoDark: (
      <JTIWhiteLogo className="h-8" title="Japan Tobacco International" />
    ),
  },
  {
    key: 'grierson',
    logo: <GriersonTrustLogo className="h-10" title="The Grierson Trust" />,
    logoDark: (
      <GriersonTrustWhiteLogo className="h-10" title="The Grierson Trust" />
    ),
  },
  {
    key: 'codewave',
    logo: <CodeWaveLogo className="h-6" title="Codewave" />,
    logoDark: <CodeWaveWhiteLogo className="h-6" title="Codewave" />,
  },
  {
    key: 'wooden-hamster',
    logo: <WoodenHamsterLogo className="h-5" title="Wooden Hamster" />,
    logoDark: <WoodenHamsterWhiteLogo className="h-5" title="Wooden Hamster" />,
  },
];

const SignUpInfo = () => {
  const { t } = useTranslation();
  const [darkMode] = useDarkMode();

  const [emblaRef] = useEmblaCarousel(
    { loop: true, duration: 40, align: 'start' },
    [AutoScroll({ playOnInit: true, stopOnInteraction: false, speed: 0.5 })],
  );

  const Brandhero = darkMode
    ? BrandheroWorkingOnComputerDark
    : BrandheroWorkingOnComputerLight;

  return (
    <>
      <h2 className="text-3xl lg:text-4xl 2xl:text-5xl leading-normal lg:leading-snug 2xl:leading-normal">
        {t('SignUpInfo.Title')}
      </h2>
      <ul className="mt-8 mb-12 lg:my-10 2xl:my-8 2xl:text-lg space-y-8">
        {VALUES.map(({ key, translationKey }) => (
          <li key={key} className="flex gap-4 items-start max-w-[468px]">
            <span className="flex bg-blue w-6 h-6 rounded-full m-1 shrink-0">
              <CheckmarkWhiteIcon className="w-3 m-auto" />
            </span>
            <span>
              <Trans i18nKey={translationKey} components={{ 1: <strong /> }} />
            </span>
          </li>
        ))}
      </ul>

      <Brandhero className="w-full lg:w-80 2xl:w-96 ml-2 mr-5 lg:mx-0" />

      <h3 className="my-8 lg:mb-6 2xl:mb-8">{t('SignUpInfo.TrustedBy')}</h3>

      <div className="max-w-full h-max overflow-hidden" ref={emblaRef}>
        <div className="flex h-full">
          {LOGOS.map(({ logo, logoDark, key }) => (
            <div className="shrink-0 my-auto ml-10" key={key}>
              {darkMode ? logoDark : logo}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SignUpInfo;
